import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';
import { VSpacer } from 'sm-react-components';


const styles = (theme) => ({
    list: {
        listStyleType: 'square'
    },
    bullets: {
        color: theme.palette.primary.main
    }

});

class ProductFeature extends Component {
    render() {
        const { image, imageText, keypoints, classes } = this.props;
        return (
            <Grid container direction='column'>
                <Grid item style={{ textAlign: 'center' }}>
                    <img src={image} alt='Product Feature' height='100px'/>
                    <div style={{ width: '60%', margin: 'auto' }}>
                        <Typography variant='h5'>
                            {imageText}
                        </Typography>
                    </div>
                </Grid>

                <VSpacer medium />
                <Grid item>
                    <ul className={classes.list}>
                        {keypoints.map(item => 
                            <li key={'pf-item-'+item} className={classes.bullets}><Typography>
                                {item}
                            </Typography>
                            </li>
                        )}
                    </ul>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(ProductFeature);